import { HttpError } from './http.error';

export class AuthError extends HttpError {
  constructor(message?: string) {
    super(401, message);
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/models/auth.error.ts